import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_tasks_projectsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId?: number, cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], top?: number, minCreationDate?: string, minProjectId?: number }): 
  Promise<{ result: { ProjectId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_tasks_projects/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId?: number, cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], top?: number, minCreationDate?: string, minProjectId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { ProjectId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_tasks_projects/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId?: number, cancelled?: boolean, shipmentTypeId?: number, shipmentIds?: number[], cutOffDate?: string, assigned?: boolean, billingAggregationStrategyIds?: number[], hasShipment?: boolean, warehouseIds?: number[], top?: number, minCreationDate?: string, minProjectId?: number, $keys: number[] }): 
  Promise<{ result: { ProjectId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_tasks_projects/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
